import React from "react";
import "../styles.scss";
const Event = (props) => {
  const { event } = props;
  const { username, user, phone_number, status } = event;
  return (
    <div className="rbc-m-custom-event">
      {/* <span
        className="material-icons delete-booking-btn"
        onClick={onDeleteClick}
      >
        delete
      </span> */}
      <ul className="rbc-m-custom-event__content">
        <li>ユーザー名 : {username || user.username}</li>
        <li>電話番号 : {phone_number || user.phone_number}</li>
        {/* <li>
          コース : {menu.map((item) => item.name).join(", ")}
        </li> */}
        <li>ステータス : {window.utils.statusMasterData[status]}</li>
      </ul>
    </div>
  );
};

export default React.memo(Event);
